import { render, staticRenderFns } from "./shopping-cart-button.vue?vue&type=template&id=6094d43b&scoped=true"
import script from "./shopping-cart-button.vue?vue&type=script&lang=js"
export * from "./shopping-cart-button.vue?vue&type=script&lang=js"
import style0 from "./shopping-cart-button.vue?vue&type=style&index=0&id=6094d43b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094d43b",
  null
  
)

export default component.exports